import { useQuery } from "@tanstack/react-query";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import { CACHE_KEY_RECURRINGTICKETS } from "../../../utils/constants";
import ticketService from "../../../services/ticketService/ticketService";

const useRecurringTickets = (page: number, pageSize: number) =>
  useQuery<TicketInterface[], Error>({
    queryKey: [
      CACHE_KEY_RECURRINGTICKETS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => ticketService.GetRecurringTickets(page, pageSize),
    initialData: [],
  });

export default useRecurringTickets;
